module.exports = __webpack_public_path__ + "src/img/baodao_on.9a6cb035.svg";